export default __webpack_public_path__ + "3b84879100407b264388f81b64b508d9.png";